import { Response } from 'superagent'
import { sendRequest } from './superagent'

export async function apiGetPortalData (): Promise<Response> {
  return await sendRequest('get', 'portaldata')
}
